// extracted by mini-css-extract-plugin
module.exports = {"container":"CreatingCanvaModal_container__3li81","svg":"CreatingCanvaModal_svg__O4zje"};